/**
 * Shared motion tokens for the coaching intro (takeover, avatar, doors reveal,
 * example player). Centralised so the choreography stays consistent and is easy
 * to tune. Durations are in seconds (framer-motion's unit); `MS` mirrors the key
 * ones in milliseconds for `setTimeout`-driven sequences.
 *
 * Every animated beat must also honour `useReducedMotion()` at the call site —
 * these tokens describe the *full-motion* path only.
 */

// A gentle "emphasized decelerate" curve — quick to start, soft to land. Used for
// the takeover card rise and other hero entrances.
export const EASE_EMPHASIZED = [0.22, 1, 0.36, 1] as const

// Standard ease-out for incidental transitions.
export const EASE_OUT = [0.16, 1, 0.3, 1] as const

export const DUR = {
  scrim: 0.24, // takeover scrim fade-in
  card: 0.36, // takeover card rise
  cardDelay: 0.08, // card trails the scrim slightly
  page: 0.22, // per-page content cross-fade
  avatarSwap: 0.12, // idle↔talking image cross-fade
  doorReveal: 0.32, // a door materialising in the tracker
} as const

// Millisecond mirrors for timer-driven sequences (e.g. the example player).
export const MS = {
  exampleTurn: 1100, // dwell between revealed example turns
  exampleTyping: 650, // typing-dots beat before a bubble lands
  exampleGap: 1400, // pause between the good and the vague example
  tooltipAutoOpen: 2600, // how long a door's label tooltip self-announces
} as const
